import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'useFunction',
  standalone: false,
})
export class UseFunctionPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.USE_FUNCTION_PC_SP:
        type = this.translate.instant('PCとスマホで使う');
        break;
      case AppConst.USE_FUNCTION_PC:
        type = this.translate.instant('PCで使う');
        break;
      case AppConst.USE_FUNCTION_SP:
        type = this.translate.instant('スマホで使う');
        break;
      case AppConst.USE_FUNCTION_NOT_USED:
        type = this.translate.instant('使わない');
        break;
    }
    return type;
  }

}
